/* ============================================================
   LW24 Quick-Add Modal · V7 "Kaufspalte im Kleinen"
   ------------------------------------------------------------
   File:    assets/quick-add.js
   Status:  LIVE seit 16.05.2026 · V7-Umbau 21.09.2026
   ------------------------------------------------------------
   ⚠️ WAS AM 21.09.2026 UMGEBAUT WURDE UND WARUM

   Das Popup hat bis heute zwei fest verdrahtete Kacheln gezeigt,
   "Standard 22cm" und "Premium XL 32cm", plus eine Zeile
   "Verwendung: Drinnen / Draussen". Beides gibt es im Katalog seit
   dem 13.08. bzw. 04.09.2026 nicht mehr: die Groessen heissen M / L /
   XL / XXL und liegen als echte Varianten vor, und die zweite Achse
   traegt jetzt USB-C / USB-A statt Drinnen/Draussen.

   Was das angerichtet hat, an der AR-15-Lampe nachgestellt:
   findRealVariant('premium xl') fand nichts, die Auswahl blieb auf
   M / USB-C stehen, das Popup schrieb aber "Premium XL · 32 cm ·
   Wohnzimmer" darueber und legte die Eigenschaft "Groesse = Premium
   XL 32cm" in den Warenkorb. Der Kunde bestellte sichtbar 32 cm,
   bezahlte 39,99€ und bekam 22 cm. Die Aufpreis-Dummies
   (53955374088532 / 53957538677076) existieren im Shop ausserdem
   nicht mehr - /cart/add.js antwortet auf sie mit 422.

   ⚠️ DESHALB KOMMEN GROESSE UND ANSCHLUSS JETZT AUS DEN VARIANTEN,
   nicht aus einer Liste im Code. Eine neue Groesse oder ein neuer
   Anschluss braucht hier keine Zeile mehr.

   ------------------------------------------------------------
   Formsprache: dieselbe wie die Kaufspalte der Produktseite
   (snippets/lw-pdp-standard-v7.liquid). Das ist Absicht und keine
   Bequemlichkeit - das Popup ist die Kaufspalte im Kleinen, und
   zwei Formsprachen fuer dieselbe Entscheidung erklaeren dem Kunden
   nur, dass es zwei Sorten Auswahl gibt. Die gibt es nicht.

     Groesse    2x2-Kacheln, Buchstabe + "ca. NN cm" + Groessenquadrat
     Anschluss  Zeilen mit Wahlpunkt links, Preis rechts
     Zusagen    getoente Flaeche, gruene Haken, 13px

   ⚠️ KEIN PREIS AUF DEN GROESSENKACHELN. Max am 10.08.2026 zur
   Produktseite: "hier soll der Kunde wirklich nachdenken welche
   Groesse er braucht und nicht direkt schauen was ist das beste fuer
   mein Geld". Dieselbe Reihenfolge gilt hier. Der Preis steht oben in
   der Preiszeile und ein zweites Mal auf dem Kaufknopf.

   ⚠️ DER PREIS AUF DEN ANSCHLUSS-ZEILEN GEHOERT DAGEGEN HIN. Max am
   21.09.2026: "bei USB-A steht nicht dem Kunden direkt da, dass er
   10€ spart". Der Abstand ist der ganze Grund, warum es die Zeile
   gibt - er darf nicht erst nach dem Klick sichtbar werden.

   ⚠️ USB-A WIRD NIE VORGEWAEHLT, solange USB-C in dieser Groesse
   lieferbar ist (Regel vom 04.09.2026, siehe Lampenwerk24/CLAUDE.md).
   Umgekehrt gilt Max' Regel vom 06.09.2026: wo nur USB-A geht, ist
   USB-A vorgewaehlt, die Ueberschrift heisst "Anschluss" statt
   "Welcher Anschluss?", und es gibt dort KEINEN Streichpreis und
   KEINE Rabattpille - § 11 PAngV, der Vorherpreis hat dort nie
   gegolten.
   ------------------------------------------------------------
   Pruefstand (kein Shopify noetig, faehrt echte Katalogstaende):
     node .github/scripts/quickadd-pruefstand.mjs
   ------------------------------------------------------------
   Public API:
     window.LWQuickAdd.open(handle)
     window.LWQuickAdd.close()
   Trigger:
     <button data-lw-quick-add="{product.handle}"> ... </button>
   Event-Dispatch nach erfolgreichem Add:
     document.dispatchEvent(new CustomEvent('cart:updated', {
       detail: { cart, source: 'quick-add' }
     }))
   ============================================================ */
(function () {
  'use strict';

  /* ---------- CONFIG ---------- */
  var MOBILE_BP = 990;

  /* Groessenachse. Der Optionswert ist der Schluessel, die Zentimeter sind
     die Anzeige. Beide Schreibweisen werden erkannt, weil im Shop waehrend
     der Umstellung noch alte Varianten liegen (siehe lw-pdp-standard-v7). */
  var CM_LABEL = { 22: 'M', 32: 'L', 42: 'XL', 52: 'XXL' };

  /* ── ⚠️ USB-C GIBT ES NUR BEI 22 CM (06.09.2026, bestaetigt 21.09.2026) ──
     Max: "USB-C gibt es nur bei 22cm aktuell. also alle anderen laufen
     aktuell nur auf USB-A also L XL XXL aktuell nur mit USB-A. M hat USB-C
     und USB-A", und am 21.09.2026 noch einmal: "aktuell geht nur USB-C bei
     den M Lampen".

     Im Shopify-Katalog gibt es die USB-C-Varianten der grossen Groessen
     weiter - an ihnen haengt die Verkaufshistorie, und "aktuell" heisst,
     der Zustand soll umkehrbar bleiben. Gesperrt wird deshalb hier, in der
     Preistabelle, ueber dasselbe available-Feld, das auch ein echtes
     Ausverkauft traegt. Damit greift die bestehende Logik von selbst: die
     USB-C-Zeile wird ausgegraut, die Auswahl springt auf USB-A, der
     Sparhinweis verschwindet, und Streichpreis wie Rabattpille bleiben weg.

     ⚠️ ZURUECKNEHMEN IST EINE ZEILE. Kommt USB-C fuer 32 cm, steht hier
     '|22|32|'. Nichts anderes muss angefasst werden.

     ⚠️ DIESELBE ZAHL STEHT IN lw-pdp-standard-v7.liquid (lwv7_usbc_cm).
     Wer eine aendert, aendert beide - sonst sagt die Produktseite etwas
     anderes als das Popup, das auf sie fuehrt.

     ⚠️ NUR BEI PRODUKTEN MIT DER ACHSE. Ohne USB-A-Varianten waere sonst
     gar nichts mehr kaufbar - die Sperre haengt deshalb an hatUsba. */
  var USBC_CM = '|22|32|';
  /* 12.10.2026: XL (42) und XXL (52) sind bis Anfang 2027 offline. Rueckweg: leeren. */
  var GROESSEN_AUS = '|42|52|';

  /* ---------- STATE ---------- */
  var dialog          = null;
  var card            = null;
  var loadingEl       = null;
  var contentEl       = null;
  var currentProduct  = null;
  var selectedVariant = null;
  var quantity        = 1;
  var isAdding        = false;
  var currentHandle   = '';
  var lastError       = null; /* {msg, isNetwork} */
  var closeTimer      = null; /* pending fade-out timer */

  var achsen   = null;  /* {motiv:-1, groesse:-1, anschluss:-1} */
  var selMotiv = null;  /* Optionswert des Motivs, null ohne Motivachse */
  var selCm    = 0;     /* 22|32|42|52 · 0 = Produkt ohne Groessenachse */
  var selAnsch = 'usbc';
  var tabelle  = null;  /* {'22': {usbc: variant, usba: variant}, ...} */
  var cms      = [];    /* Groessen des gewaehlten Motivs, aufsteigend */
  var hatUsba  = false; /* traegt das gewaehlte Motiv ueberhaupt USB-A? */
  /* ⚠️ HAT DER KUNDE USB-A GEWAEHLT, ODER BLIEB IHM NICHTS ANDERES?
     Der Unterschied entscheidet, was beim Groessenwechsel mitgeht. Wer bei
     L landet, bekommt USB-A von der Sperre aufgezwungen (USBC_CM). Wandert
     diese erzwungene Wahl mit zurueck nach M, steht der Kunde auf USB-A,
     ohne es je angeklickt zu haben - genau die stille Vorauswahl, die die
     Regel vom 04.09.2026 verbietet. Eine ECHTE Wahl dagegen soll einen
     Groessenwechsel ueberleben. */
  var anschGewaehlt = false;

  /* ---------- HELPERS ---------- */
  function isMobile() { return window.innerWidth < MOBILE_BP; }

  /* Memory feedback_euro_format_ohne_space: kein Space zwischen Zahl und € */
  function num(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function eur(cents) { return num(cents) + '€'; }
  function formatMoney(cents) { return eur(cents); }

  /* Ersparnis wie auf der Produktseite: glatte Betraege ohne Nachkommastellen.
     Das Zeichen ist ein MINUS (U+2212), kein Gedankenstrich - die Regel aus
     CLAUDE.md meint die beiden Striche im Fliesstext, nicht das Rechenzeichen. */
  function sparText(cents) {
    return '−' + (cents % 100 === 0 ? (cents / 100).toLocaleString('de-DE') : num(cents)) + ' €';
  }

  function escHtml(str) {
    var d = document.createElement('div');
    d.textContent = (str == null ? '' : String(str));
    return d.innerHTML;
  }

  function imgUrl(src, size) {
    if (!src) return '';
    return String(src).replace(/(\.[^.\/?]+)(\?|$)/, '_' + size + '$1$2').replace('http:', 'https:');
  }

  function getOptionName(opt) {
    if (opt && typeof opt === 'object') return opt.name || '';
    return String(opt || '');
  }

  /* ---------- ACHSEN-ERKENNUNG ----------
     Ueber den Namen der Option, nicht ueber ihre Position: bei den
     Sammelprodukten steht die Groesse an Position 2, bei den Einzellampen
     an Position 1. Genau diese Verwechslung hat auf der Produktseite schon
     dreimal das falsche Motiv in den Warenkorb gelegt (siehe die
     Kommentare an der Kachelschleife in lw-pdp-standard-v7). */
  function erkenneAchsen(p) {
    var a = { motiv: -1, groesse: -1, anschluss: -1 };
    if (!p.options) return a;
    for (var i = 0; i < p.options.length; i++) {
      var n = getOptionName(p.options[i]).toLowerCase();
      if (n === 'motiv' || n === 'design') a.motiv = i;
      else if (n === 'größe' || n === 'groesse' || n === 'size') a.groesse = i;
      else if (n === 'anschluss') a.anschluss = i;
    }
    return a;
  }

  function pipes(v) {
    return '|' + (v.option1 || '') + '|' + (v.option2 || '') + '|' + (v.option3 || '') + '|';
  }

  /* Zentimeter einer Variante. Erst der exakte Optionswert zwischen Pipes
     gesucht - damit "XL" nicht auch "XXL" oder das alte "Premium XL 32cm"
     trifft -, dann die alten Namen. Ohne Treffer 0: die Variante zaehlt
     dann nicht zur Groessenachse. */
  function cmVon(v) {
    var p = pipes(v);
    if (p.indexOf('|M|')   !== -1) return 22;
    if (p.indexOf('|L|')   !== -1) return 32;
    if (p.indexOf('|XL|')  !== -1) return 42;
    if (p.indexOf('|XXL|') !== -1) return 52;
    var t = (v.title || '') + ' ' + p;
    if (/22\s?cm/.test(t)) return 22;
    if (/32\s?cm/.test(t)) return 32;
    if (/42\s?cm/.test(t)) return 42;
    if (/52\s?cm/.test(t)) return 52;
    return 0;
  }

  /* Ohne Treffer gilt USB-C: Produkte, die die Achse (noch) nicht tragen,
     verhalten sich damit exakt wie vorher. */
  function anschVon(v) {
    return pipes(v).indexOf('|USB-A|') !== -1 ? 'usba' : 'usbc';
  }

  /* "4-teilig" fuer XL und XXL, dieselbe Regel wie snippets/lw-montage-teile.
     Vorgabe ist 4, der Tag `montage-2` macht 2 daraus. Klein verglichen und
     zwischen Pipes gesucht, damit `montage-2` nicht auch `montage-24` trifft. */
  function montageText(cm) {
    if (cm < 42) return '';
    var teile = 4;
    var tags = '|' + (currentProduct.tags || []).join('|').toLowerCase() + '|';
    if (tags.indexOf('|montage-2|') !== -1) teile = 2;
    if (tags.indexOf('|montage-4|') !== -1) teile = 4;
    return teile + '-teilig';
  }

  /* ---------- PREISTABELLE ----------
     EINE Schleife ordnet Groesse und Anschluss zu, und zwar nur fuer das
     gewaehlte Motiv. Bei den Sammelprodukten ist das Raster luecken-
     haft: "Altenheim Lampe" gibt es in M/USB-C, M/USB-A und L/USB-A - also
     keine L/USB-C-Zeile und kein XL. Wer ueber ALLE Varianten laeuft, zeigt
     dem Kunden Groessen, die es fuer SEIN Motiv nicht gibt. */
  function baueTabelle() {
    tabelle = {};
    cms = [];
    hatUsba = false;
    if (!currentProduct || !currentProduct.variants) return;

    /* Erster Durchlauf: die Varianten DIESES Motivs einsammeln und dabei
       beantworten, ob es ueberhaupt eine USB-A-Reihe gibt. Die Frage muss
       vor dem Einsortieren feststehen, weil die USB-C-Sperre daran haengt -
       ohne USB-A waere sonst gar nichts mehr kaufbar. */
    var meine = [];
    for (var i = 0; i < currentProduct.variants.length; i++) {
      var v = currentProduct.variants[i];
      if (achsen.motiv >= 0 && selMotiv != null && v.options[achsen.motiv] !== selMotiv) continue;
      if (!cmVon(v)) continue;
      if (GROESSEN_AUS.indexOf('|' + cmVon(v) + '|') !== -1) continue;
      meine.push(v);
      if (anschVon(v) === 'usba') hatUsba = true;
    }

    for (var j = 0; j < meine.length; j++) {
      var w = meine[j];
      var cm = cmVon(w);
      var a = anschVon(w);
      if (!tabelle[cm]) { tabelle[cm] = { usbc: null, usba: null }; cms.push(cm); }
      /* Erste gewinnt: bei doppelten Varianten derselben Kombination ist die
         erste die, die Shopify auch im Varianten-Picker zeigt. */
      if (tabelle[cm][a]) continue;
      var gesperrt = hatUsba && a === 'usbc' && USBC_CM.indexOf('|' + cm + '|') === -1;
      tabelle[cm][a] = gesperrt ? ohneVerfuegbarkeit(w) : w;
    }
    cms.sort(function (x, y) { return x - y; });
  }

  /* Eine Kopie der Variante, die als nicht lieferbar gilt. KOPIE und nicht
     v.available = false: das Produktobjekt kommt aus /products/*.js und wird
     von den Motivkacheln und den Restoptionen ebenfalls gelesen - wer es
     hier verbiegt, dreht dort still die Verfuegbarkeit mit. */
  function ohneVerfuegbarkeit(v) {
    var k = {};
    for (var key in v) {
      if (Object.prototype.hasOwnProperty.call(v, key)) k[key] = v[key];
    }
    k.available = false;
    return k;
  }

  function groesseLieferbar(cm) {
    var e = tabelle && tabelle[cm];
    if (!e) return false;
    return !!((e.usbc && e.usbc.available) || (e.usba && e.usba.available));
  }

  /* USB-A wird nie vorgewaehlt, solange USB-C in dieser Groesse geht. Ist
     USB-C dort nicht lieferbar, faellt die Wahl auf USB-A - das ist Max'
     Regel vom 06.09.2026 und kein Widerspruch: der Kunde soll SEHEN, dass
     er USB-A kauft, statt heimlich darauf zu landen. */
  function anschlussFuer(cm) {
    var e = (tabelle && tabelle[cm]) || {};
    if (e.usbc && e.usbc.available) return 'usbc';
    if (e.usba && e.usba.available) return 'usba';
    return e.usbc ? 'usbc' : 'usba';
  }

  function varianteFuer(cm, ansch) {
    var e = tabelle && tabelle[cm];
    if (!e) return null;
    return e[ansch] || e.usbc || e.usba || null;
  }

  /* Startauswahl. M ist die beliebteste Wahl und der Preis, mit dem geworben
     wird ("ab 29,99€") - wenn es sie gibt, steht sie vorne. */
  function waehleStart() {
    var lieferbar = cms.filter(groesseLieferbar);
    var liste = lieferbar.length ? lieferbar : cms;
    selCm = liste.indexOf(22) !== -1 ? 22 : (liste[0] || 0);
    if (selCm) {
      selAnsch = anschlussFuer(selCm);
      selectedVariant = varianteFuer(selCm, selAnsch);
    }
  }

  /* Produkte ohne Groessenachse (LED-Streifen, Sets, Einzelvarianten) fallen
     auf die alte Auswahl zurueck: erste lieferbare Variante. */
  function waehleOhneGroesse() {
    selectedVariant = currentProduct.variants[0];
    for (var i = 0; i < currentProduct.variants.length; i++) {
      if (currentProduct.variants[i].available) { selectedVariant = currentProduct.variants[i]; break; }
    }
  }

  /* ---------- DIALOG SETUP (native <dialog>) ---------- */
  function ensureDialog() {
    if (dialog && document.body.contains(dialog)) return;

    dialog = document.createElement('dialog');
    dialog.className = 'lw-qa';
    dialog.setAttribute('aria-labelledby', 'lw-qa-title');

    dialog.innerHTML =
      '<div class="lw-qa__shell" data-lw-qa-backdrop>' +
        '<div class="lw-qa__card" role="dialog" aria-modal="true">' +
          '<button class="lw-qa__close" type="button" aria-label="Schließen" data-lw-qa-close>' +
            '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
              '<path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
          '<div class="lw-qa__loading" data-lw-qa-loading>' +
            '<div class="lw-qa__skeleton-row">' +
              '<div class="lw-qa__skeleton lw-qa__skeleton--img"></div>' +
              '<div class="lw-qa__skeleton-stack">' +
                '<div class="lw-qa__skeleton lw-qa__skeleton--text"></div>' +
                '<div class="lw-qa__skeleton lw-qa__skeleton--text-sm"></div>' +
              '</div>' +
            '</div>' +
            '<div class="lw-qa__skeleton lw-qa__skeleton--pill"></div>' +
            '<div class="lw-qa__skeleton lw-qa__skeleton--pill"></div>' +
          '</div>' +
          '<div data-lw-qa-content style="display:none;flex:1;flex-direction:column;min-height:0;"></div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(dialog);

    card      = dialog.querySelector('.lw-qa__card');
    loadingEl = dialog.querySelector('[data-lw-qa-loading]');
    contentEl = dialog.querySelector('[data-lw-qa-content]');

    /* Close-Triggers */
    dialog.querySelector('[data-lw-qa-close]').addEventListener('click', closeModal);
    dialog.addEventListener('click', function (e) {
      /* Click ausserhalb der Card -> schliessen */
      if (e.target === dialog || e.target.hasAttribute('data-lw-qa-backdrop')) {
        closeModal();
      }
    });

    /* native ESC + ::backdrop click triggern 'cancel' */
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeModal();
    });
  }

  /* ---------- OPEN / CLOSE ---------- */
  function openModal(handle) {
    ensureDialog();
    currentHandle = handle;
    lastError = null;

    /* State reset */
    quantity = 1;
    isAdding = false;
    achsen   = { motiv: -1, groesse: -1, anschluss: -1 };
    selMotiv = null;
    selCm    = 0;
    selAnsch = 'usbc';
    tabelle  = null;
    cms      = [];
    hatUsba  = false;
    anschGewaehlt = false;

    /* Loading-State */
    if (loadingEl) loadingEl.style.display = '';
    if (contentEl) { contentEl.style.display = 'none'; contentEl.innerHTML = ''; }

    /* Fix: pending close-fade abbrechen */
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (card) { card.style.opacity = ''; card.style.transform = ''; }

    if (!dialog.open) dialog.showModal();
    document.body.classList.add('lw-qa-open');

    fetchProduct(handle);
  }

  function closeModal() {
    if (!dialog || !dialog.open) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    /* Fade-out via Card-Transition, dann close() */
    card.style.opacity = '0';
    card.style.transform = isMobile() ? 'translateY(8px)' : 'scale(0.96)';
    closeTimer = setTimeout(function () {
      closeTimer = null;
      try { dialog.close(); } catch (e) {}
      card.style.opacity = '';
      card.style.transform = '';
      document.body.classList.remove('lw-qa-open');
    }, 220);
  }

  /* ---------- FETCH PRODUCT ---------- */
  function fetchProduct(handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (product) {
        try {
          uebernehmen(product);
          renderContent();
        } catch (e) {
          console.error('[LWQuickAdd] Render error:', e);
          showFetchError(handle);
        }
      })
      .catch(function (err) {
        console.error('[LWQuickAdd] Fetch error for "' + handle + '":', err);
        showFetchError(handle);
      });
  }

  /* Produkt uebernehmen und Startauswahl setzen. Eigene Funktion, weil der
     Pruefstand genau hier einsteigt - er kennt kein fetch(). */
  function uebernehmen(product) {
    currentProduct = product;
    achsen = erkenneAchsen(product);

    /* Motiv: erstes Motiv mit lieferbarer Variante, sonst das erste. */
    if (achsen.motiv >= 0) {
      selMotiv = product.variants[0].options[achsen.motiv];
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          selMotiv = product.variants[i].options[achsen.motiv];
          break;
        }
      }
    }

    baueTabelle();
    if (cms.length) waehleStart(); else waehleOhneGroesse();
  }

  function showFetchError(handle) {
    if (loadingEl) loadingEl.style.display = 'none';
    if (!contentEl) return;
    contentEl.innerHTML =
      '<div class="lw-qa__fetch-error">' +
        '<p>Das hat nicht geklappt. Prüf kurz deine Verbindung.</p>' +
        '<a href="/products/' + escHtml(handle) + '">Zum Produkt</a>' +
      '</div>';
    contentEl.style.display = 'flex';
  }

  /* ---------- RENDER ---------- */
  function renderContent() {
    var p = currentProduct;
    var v = selectedVariant;

    if (loadingEl) loadingEl.style.display = 'none';
    if (!contentEl) return;
    if (!v) { showFetchError(currentHandle); return; }

    var imgSrc = v.featured_image ? v.featured_image.src : (p.featured_image || '');
    if (imgSrc) imgSrc = imgUrl(imgSrc, '240x240');

    var html = '';

    /* Body */
    html += '<div class="lw-qa__body">';

    /* Head */
    html += '<div class="lw-qa__head">';
    html +=   '<div class="lw-qa__thumb">';
    if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + escHtml(p.title) + '" loading="eager">';
    html +=   '</div>';
    html +=   '<div class="lw-qa__head-info">';
    html +=     '<h3 class="lw-qa__title" id="lw-qa-title">' + escHtml(p.title) + '</h3>';
    /* Streichpreis-Zeile ueber dem grossen Preis. Sie steht IMMER da, auch
       leer, damit die Preiszeile beim Umschalten auf USB-A nicht springt.
       Beschriftet, weil § 11 PAngV verlangt, dass klar ist, WORAUF sich der
       durchgestrichene Betrag bezieht - er ist kein Vorherpreis. */
    html +=     '<span class="lw-qa__was" data-lw-qa-was>&nbsp;</span>';
    html +=     '<div class="lw-qa__price-line" data-lw-qa-price>' + buildPriceHtml(v) + '</div>';
    /* 10.08.2026: hier stand "Versand 5-7 Tage". Die Lieferzeit haengt an der
       Groesse (Termin-Rechner: 22 cm 5-7, ab 32 cm 10-12) und die kennt das
       Quick-Add beim Aufklappen nicht. Statt einer falschen Zahl der
       Pflichthinweis, der hier sowieso hingehoert. */
    html +=     '<span class="lw-qa__meta">inkl. MwSt. · zzgl. Versandkosten</span>';
    html +=   '</div>';
    html += '</div>';

    /* Zusagen. Bis zum 21.09.2026 drei 10,5px-Pillen in einer Zeile - Max:
       "aktuell sind die USPs zu klein". Jetzt dieselbe Bauform wie die drei
       Vertrauenszeilen der Produktseite (.lwv7-rows): getoente Flaeche,
       gruene Haken-Scheibe, 13px, fuehrendes Wort fett. */
    html += renderZusagen();

    /* Motiv */
    if (achsen.motiv >= 0) html += renderMotiv(p);

    /* Groesse und Anschluss haengen am gewaehlten Motiv und werden beim
       Motivwechsel als Block neu gebaut - die Motivkacheln bleiben stehen. */
    html += '<div data-lw-qa-waehler>' + renderWaehler() + '</div>';

    html += '</div>'; /* /body */

    /* Footer */
    html += '<div class="lw-qa__footer">';
    html +=   '<button class="lw-qa__cta" type="button" data-lw-qa-add' + (v.available ? '' : ' disabled') + '>';
    html +=     '<span class="lw-qa__cta-text lw-qa__cta-text-default">' + ctaText(v) + '</span>';
    html +=     '<span class="lw-qa__cta-text lw-qa__cta-text-loading"><span class="lw-qa__cta-spinner"></span>Wird hinzugefügt…</span>';
    html +=     '<span class="lw-qa__cta-text lw-qa__cta-text-success">✓ Hinzugefügt</span>';
    html +=   '</button>';
    html +=   '<div class="lw-qa__error" data-lw-qa-error role="alert" aria-live="polite"></div>';
    html += '</div>';

    contentEl.innerHTML = html;
    contentEl.style.display = 'flex';

    bindEvents();
    updateWas();
    fixThumbLazyLoad();
  }

  /* Der Preis steht auf dem Knopf, weil das Popup keine Preiszeile ueber
     dem Knopf hat wie die Produktseite. Wer bis hierher gescrollt ist,
     sieht die Summe, ohne wieder hochzusehen.

     ⚠️ "IN DEN WARENKORB", NICHT "IN MEINE TASCHE" (22.09.2026). Max:
     "es heisst nicht mehr 'in meine tasche' sondern einfach nur in den
     warenkorb". Der Kaufknopf der Produktseite (.lwv7-atc) hiess schon
     immer so - das Popup, die Sticky-Leiste und die Motiv-Box waren die
     drei Stellen, die noch die alte Formel trugen. Jetzt sagt jeder
     Kaufknopf im Shop dasselbe. */
  function ctaText(v) {
    if (!v || !v.available) return 'Ausverkauft';
    return 'In den Warenkorb · ' + eur(v.price * quantity);
  }

  function renderZusagen() {
    var rows = [
      ['Made in Germany', 'in eigener Werkstatt gedruckt'],
      ['Versand mit DHL', 'aus Deutschland'],
      ['14 Tage Rückgabe', 'ohne Begründung']
    ];
    var html = '<div class="lw-qa__trust">';
    for (var i = 0; i < rows.length; i++) {
      html += '<div class="lw-qa__trust-row">' +
                '<span class="lw-qa__trust-ic" aria-hidden="true">✓</span>' +
                '<span><b>' + rows[i][0] + '</b> ' + rows[i][1] + '</span>' +
              '</div>';
    }
    html += '</div>';
    return html;
  }

  function buildPriceHtml(v) {
    var html = '';
    if (v.compare_at_price && v.compare_at_price > v.price) {
      var discount = Math.round((1 - v.price / v.compare_at_price) * 100);
      html += '<span class="lw-qa__price-compare">' + formatMoney(v.compare_at_price) + '</span>';
      html += '<span class="lw-qa__price">' + formatMoney(v.price) + '</span>';
      html += '<span class="lw-qa__price-sale">-' + discount + '%</span>';
    } else {
      html += '<span class="lw-qa__price">' + formatMoney(v.price) + '</span>';
    }
    return html;
  }

  /* ---------- MOTIV-KACHELN ---------- */
  function renderMotiv(p) {
    var idx = achsen.motiv;
    var werte = [];
    var gesehen = {};
    for (var k = 0; k < p.variants.length; k++) {
      var val = p.variants[k].options[idx];
      if (gesehen[val]) {
        if (p.variants[k].available) gesehen[val].available = true;
        if (!gesehen[val].image && p.variants[k].featured_image) {
          gesehen[val].image = p.variants[k].featured_image.src;
        }
        continue;
      }
      gesehen[val] = {
        name: val,
        available: p.variants[k].available,
        image: p.variants[k].featured_image ? p.variants[k].featured_image.src : null
      };
      werte.push(gesehen[val]);
    }

    var hatBilder = werte.some(function (w) { return !!w.image; });
    var optionName = getOptionName(p.options[idx]);

    var html = '<div class="lw-qa__section">';
    html +=   '<div class="lw-qa__qtop"><b>Wähle dein ' + escHtml(optionName) + '</b>' +
              '<span data-lw-qa-motiv-name>' + escHtml(selMotiv) + '</span></div>';

    /* Bildkacheln bei bis zu 24 Motiven, sonst Ausklappliste: darueber wird
       das Raster hoeher als das Popup und der Kunde scrollt an der Groesse
       vorbei, ohne sie gesehen zu haben. */
    if (hatBilder && werte.length <= 24) {
      html += '<div class="lw-qa__tiles" data-lw-qa-tiles>';
      for (var m = 0; m < werte.length; m++) {
        var aktiv = werte[m].name === selMotiv;
        var imgS = werte[m].image ? imgUrl(werte[m].image, '160x160') : '';
        html += '<button type="button" class="lw-qa__tile' +
                (aktiv ? ' is-active' : '') +
                (!werte[m].available ? ' is-unavailable' : '') + '"' +
                ' data-motiv="' + escHtml(werte[m].name) + '"' +
                ' title="' + escHtml(werte[m].name) + '"' +
                (!werte[m].available ? ' aria-disabled="true"' : '') + '>';
        if (imgS) {
          /* loading="eager" - Bug-Fix Lazy-Load nicht-sichtbar-im-Dialog (Brief) */
          html += '<img src="' + imgS + '" alt="' + escHtml(werte[m].name) + '" loading="eager" decoding="async">';
        }
        html += '</button>';
      }
      html += '</div>';
    } else {
      html += '<div class="lw-qa__dropdown-wrap">';
      html +=   '<select class="lw-qa__dropdown" data-lw-qa-motiv-select>';
      for (var n = 0; n < werte.length; n++) {
        var sel = werte[n].name === selMotiv ? ' selected' : '';
        var dis = !werte[n].available ? ' disabled' : '';
        html += '<option value="' + escHtml(werte[n].name) + '"' + sel + dis + '>' +
                escHtml(werte[n].name) + (!werte[n].available ? ' (Ausverkauft)' : '') + '</option>';
      }
      html +=   '</select>';
      html +=   '<svg class="lw-qa__dropdown-arrow" viewBox="0 0 10 6"><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>';
      html += '</div>';
    }
    html += '</div>';
    return html;
  }

  /* ---------- GROESSE + ANSCHLUSS ---------- */
  function renderWaehler() {
    if (!cms.length) return renderRestOptionen();
    return renderGroesse() + renderAnschluss();
  }

  var SQ_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
               'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
               '<polyline points="8 7 3 12 8 17"/><polyline points="16 7 21 12 16 17"/>' +
               '<line x1="3" y1="12" x2="21" y2="12"/></svg>';

  function renderGroesse() {
    /* Eine Groesse ist keine Wahl. Dann steht sie als Zeile da, damit der
       Kunde trotzdem weiss, was er kauft - eine einzelne Kachel saehe aus
       wie eine Auswahl, die nicht geht. */
    if (cms.length === 1) {
      return '<div class="lw-qa__section">' +
               '<div class="lw-qa__qtop"><b>Größe</b><span>' +
               escHtml(CM_LABEL[cms[0]] || '') + ' · ca. ' + cms[0] + ' cm</span></div>' +
             '</div>';
    }

    var html = '<div class="lw-qa__section">';
    html +=   '<div class="lw-qa__qtop"><b>Welche Größe?</b>' +
              '<span>an der längsten Kante</span></div>';
    html +=   '<div class="lw-qa__sizes" role="radiogroup" aria-label="Welche Größe?">';
    for (var i = 0; i < cms.length; i++) {
      var cm = cms[i];
      var da = groesseLieferbar(cm);
      var mont = montageText(cm);
      html += '<button type="button" class="lw-qa__scard' +
              (cm === 22 ? ' lw-qa__scard--feat' : '') +
              (mont ? ' lw-qa__scard--mont' : '') +
              (cm === selCm ? ' is-on' : '') +
              (!da ? ' is-off' : '') + '"' +
              ' data-cm="' + cm + '"' +
              ' role="radio" aria-checked="' + (cm === selCm ? 'true' : 'false') + '"' +
              (da ? '' : ' disabled aria-disabled="true"') + '>';
      /* "Beliebteste Wahl" liegt auf M und ist im ganzen Shop gleich
         gestaltet (Groesse und Menge, siehe .lwv7-rib). */
      if (cm === 22) html += '<span class="lw-qa__rib">Beliebteste Wahl</span>';
      html +=   '<b>' + (CM_LABEL[cm] || '') + '</b>';
      html +=   '<i>ca. ' + cm + ' cm</i>';
      if (mont) html += '<span class="lw-qa__mont">' + mont + '</span>';
      html +=   '<span class="lw-qa__sq lw-qa__sq--' + cm + '">' + SQ_SVG + '</span>';
      html += '</button>';
    }
    html +=   '</div>';
    html += '</div>';
    return html;
  }

  function renderAnschluss() {
    var e = (tabelle && tabelle[selCm]) || {};
    /* Der Block erscheint nur, wenn es fuer dieses Motiv wirklich eine
       USB-A-Reihe gibt. Lampen ohne die Achse sehen das Popup von vorher.
       hatUsba steht seit baueTabelle() fest - dieselbe Antwort, an der auch
       die USB-C-Sperre haengt, damit beide nicht auseinanderlaufen koennen. */
    if (!hatUsba) return '';

    var refC   = e.usbc;
    var refA   = e.usba;
    var nurEin = !(refC && refC.available);

    /* Ersparnis JE LAMPE, nicht fuer die Menge: die Zeile im Kopf soll beim
       Mengenwechsel stillstehen. Ausgerechnet statt "10 €" hart im Text,
       sonst behauptet sie beim naechsten Preisdreher etwas Falsches - und
       genau das faellt niemandem auf. */
    var spar = (refC && refC.available && refA && refA.available) ? (refC.price - refA.price) : 0;

    var html = '<div class="lw-qa__section">';
    html +=   '<div class="lw-qa__qtop"><b>' + (nurEin ? 'Anschluss' : 'Welcher Anschluss?') + '</b>' +
              '<span class="lw-qa__spar">' +
              (spar > 0 ? 'USB-A: ' + sparText(spar).replace('−', '') + ' günstiger' : '') +
              '</span></div>';
    html +=   '<div class="lw-qa__arows" role="radiogroup" aria-label="Anschluss">';

    html += anschlussZeile('usbc', 'USB-C',
              nurEin ? nurInText() : 'Läuft an jedem USB-C-Netzteil',
              refC, refC, false);
    html += anschlussZeile('usba', 'USB-A',
              nurEin ? 'Adapter liegt bei' : 'Adapter liegt bei, Restbestand',
              refA, refC, !nurEin);

    html +=   '</div>';
    html += '</div>';
    return html;
  }

  /* "Aktuell nur in 22 cm" wird aus der Tabelle gelesen und nicht
     hingeschrieben: kommt USB-C fuer 32 cm dazu, stimmt der Satz von selbst. */
  function nurInText() {
    var mit = [];
    for (var i = 0; i < cms.length; i++) {
      var e = tabelle[cms[i]];
      if (e && e.usbc && e.usbc.available) mit.push(cms[i] + ' cm');
    }
    if (!mit.length) return 'Zurzeit nicht lieferbar';
    if (mit.length === 1) return 'Aktuell nur in ' + mit[0];
    return 'Aktuell nur in ' + mit.slice(0, -1).join(', ') + ' und ' + mit[mit.length - 1];
  }

  /* Eine Anschluss-Zeile. `ref` ist die USB-C-Variante derselben Groesse -
     der Bezugspreis fuer Streichpreis und Rabattpille. Ist sie in dieser
     Groesse nicht lieferbar, gibt es beides NICHT: § 11 PAngV, der
     Vorherpreis hat dort nie gegolten (siehe Kopf der Datei). */
  function anschlussZeile(key, name, sub, v, ref, mitRabatt) {
    var da = !!(v && v.available);
    var preis = da ? eur(v.price * quantity) : 'nicht lieferbar';
    var spar = (da && mitRabatt && ref && ref.available) ? (ref.price - v.price) * quantity : 0;

    var html = '<button type="button" class="lw-qa__arow' +
               (key === selAnsch ? ' is-on' : '') +
               (!da ? ' is-off' : '') + '"' +
               ' data-ansch="' + key + '"' +
               ' role="radio" aria-checked="' + (key === selAnsch ? 'true' : 'false') + '"' +
               (da ? '' : ' disabled aria-disabled="true"') + '>';
    html +=   '<span class="lw-qa__adot" aria-hidden="true"></span>';
    html +=   '<span class="lw-qa__atxt"><b>' + name + '</b><small>' + escHtml(sub) + '</small></span>';
    html +=   '<span class="lw-qa__app">';
    if (spar > 0) html += '<s>' + eur(ref.price * quantity) + '</s>';
    html +=     '<em>' + preis + '</em>';
    if (spar > 0) html += '<span class="lw-qa__pct">' + sparText(spar) + '</span>';
    html +=   '</span>';
    html += '</button>';
    return html;
  }

  /* Produkte ohne Groessenachse: jede uebrige Option als Pillenreihe. Das
     ist der alte Weg und faengt LED-Streifen, Sets und alles ab, was die
     neue Achsenwelt (noch) nicht mitmacht. */
  function renderRestOptionen() {
    var p = currentProduct;
    var html = '';
    if (!p.options || p.variants.length <= 1) return html;

    for (var oi = 0; oi < p.options.length; oi++) {
      if (oi === achsen.motiv) continue;
      var oName = getOptionName(p.options[oi]);
      var werte = [];
      var seen = {};
      for (var vi = 0; vi < p.variants.length; vi++) {
        var oVal = p.variants[vi].options[oi];
        if (seen[oVal]) continue;
        seen[oVal] = true;
        werte.push({ name: oVal, available: p.variants[vi].available });
      }
      if (werte.length < 2) continue;

      html += '<div class="lw-qa__section">';
      html +=   '<div class="lw-qa__qtop"><b>' + escHtml(oName) + '</b>' +
                '<span>' + escHtml(selectedVariant.options[oi]) + '</span></div>';
      html +=   '<div class="lw-qa__pills">';
      for (var wi = 0; wi < werte.length; wi++) {
        var aktiv = werte[wi].name === selectedVariant.options[oi];
        html += '<button type="button" class="lw-qa__pill' +
                (aktiv ? ' is-active' : '') +
                (!werte[wi].available ? ' is-disabled' : '') + '"' +
                ' data-option-index="' + oi + '"' +
                ' data-option-value="' + escHtml(werte[wi].name) + '"' +
                (!werte[wi].available ? ' disabled' : '') + '>' +
                escHtml(werte[wi].name) +
                '</button>';
      }
      html +=   '</div>';
      html += '</div>';
    }
    return html;
  }

  /* ---------- LAZY-LOAD FIX ---------- */
  /* Browser geben dem <dialog> initial display:none -> IntersectionObserver
     feuert nicht. Wir setzen alle Tiles auf loading="eager" und prüfen
     nach Dialog-Open zusätzlich ob img.complete; falls nicht, src neu setzen. */
  function fixThumbLazyLoad() {
    if (!contentEl) return;
    var imgs = contentEl.querySelectorAll('.lw-qa__tile img, .lw-qa__thumb img');
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      var src = img.getAttribute('src');
      if (src) {
        img.removeAttribute('loading');
        /* trigger load: src nochmal setzen (Safari quirk) */
        img.setAttribute('src', src);
      }
    });
  }

  /* ---------- BIND EVENTS ---------- */
  function bindEvents() {
    /* Motiv-Kacheln */
    var tiles = contentEl.querySelector('[data-lw-qa-tiles]');
    if (tiles) {
      tiles.addEventListener('click', function (e) {
        var btn = e.target.closest('.lw-qa__tile');
        if (!btn || btn.classList.contains('is-unavailable')) return;

        tiles.querySelectorAll('.lw-qa__tile').forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');

        /* Aktive Kachel an Position 1 (UX-Pattern project_variant_picker_ux) */
        if (tiles.firstElementChild !== btn) {
          tiles.insertBefore(btn, tiles.firstElementChild);
        }

        setMotiv(btn.getAttribute('data-motiv'));
      });
    }

    /* Motiv-Ausklappliste */
    var motivSelect = contentEl.querySelector('[data-lw-qa-motiv-select]');
    if (motivSelect) {
      motivSelect.addEventListener('change', function () { setMotiv(this.value); });
    }

    bindWaehler();

    /* Pillen der Restoptionen (Produkte ohne Groessenachse) */
    contentEl.querySelectorAll('.lw-qa__pill[data-option-index]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('is-disabled')) return;
        var optIdx = parseInt(pill.getAttribute('data-option-index'), 10);
        var optVal = pill.getAttribute('data-option-value');
        contentEl.querySelectorAll('.lw-qa__pill[data-option-index="' + optIdx + '"]')
          .forEach(function (x) { x.classList.remove('is-active'); });
        pill.classList.add('is-active');

        var opts = selectedVariant.options.slice();
        opts[optIdx] = optVal;
        for (var i = 0; i < currentProduct.variants.length; i++) {
          var v = currentProduct.variants[i];
          var match = true;
          for (var j = 0; j < opts.length; j++) {
            if (v.options[j] !== opts[j]) { match = false; break; }
          }
          if (match) { selectedVariant = v; break; }
        }
        updateImage(); updatePrice(); updateButton();
      });
    });

    /* CTA */
    var cta = contentEl.querySelector('[data-lw-qa-add]');
    if (cta) cta.addEventListener('click', addToCart);
  }

  /* Groesse und Anschluss werden beim Motivwechsel neu gebaut - ihre
     Handler haengen deshalb am Container, nicht an den Knoepfen. */
  function bindWaehler() {
    var box = contentEl.querySelector('[data-lw-qa-waehler]');
    if (!box || box._lwBound) return;
    box._lwBound = true;

    box.addEventListener('click', function (e) {
      var sc = e.target.closest('.lw-qa__scard');
      if (sc && !sc.disabled) { setGroesse(parseInt(sc.getAttribute('data-cm'), 10)); return; }
      var ar = e.target.closest('.lw-qa__arow');
      if (ar && !ar.disabled) { setAnschluss(ar.getAttribute('data-ansch')); return; }
    });
  }

  /* ---------- AUSWAHL ---------- */
  function setMotiv(name) {
    if (!name || name === selMotiv) return;
    selMotiv = name;
    var altCm = selCm, altA = selAnsch;

    baueTabelle();
    if (!cms.length) {
      waehleOhneGroesse();
    } else if (tabelle[altCm] && groesseLieferbar(altCm)) {
      /* Groesse und Anschluss mitnehmen, wenn es sie fuer das neue Motiv
         gibt. Ohne diesen Schritt landet man bei jedem Motivwechsel wieder
         auf M - und merkt es erst im Warenkorb. */
      selCm = altCm;
      var e = tabelle[selCm];
      var mitA = e[altA] && e[altA].available &&
                 (altA === 'usbc' || anschGewaehlt);
      selAnsch = mitA ? altA : anschlussFuer(selCm);
      selectedVariant = varianteFuer(selCm, selAnsch);
    } else {
      waehleStart();
    }

    var lbl = contentEl && contentEl.querySelector('[data-lw-qa-motiv-name]');
    if (lbl) lbl.textContent = selMotiv;
    redrawWaehler();
    updateImage(); updatePrice(); updateButton(); updateWas();
  }

  function setGroesse(cm) {
    if (!cm || cm === selCm) return;
    /* ⚠️ NUR GROESSEN, DIE ES FUER DIESES MOTIV GIBT. Ueber die Kacheln ist
       nichts anderes anklickbar, aber varianteFuer() gibt fuer eine
       unbekannte Groesse null zurueck - und mit selectedVariant === null
       faellt der naechste Klick auf den Kaufknopf still aus, waehrend das
       Popup weiter einen Preis anzeigt. Gefunden am 21.09.2026 beim Lauf
       gegen den echten Katalog. */
    if (!tabelle || !tabelle[cm]) return;
    selCm = cm;
    var e = (tabelle && tabelle[selCm]) || {};
    /* Anschluss mitnehmen, solange er in der neuen Groesse lieferbar ist UND
       der Kunde ihn selbst gewaehlt hat. Ein von der Sperre erzwungenes
       USB-A wandert NICHT mit: sonst steht man nach dem Umweg ueber L
       wieder bei M auf USB-A, ohne es angeklickt zu haben.
       Greift anschlussFuer(), waehlt die USB-A nur, wenn USB-C dort
       wirklich nicht geht. */
    var mitnehmen = e[selAnsch] && e[selAnsch].available &&
                    (selAnsch === 'usbc' || anschGewaehlt);
    selAnsch = mitnehmen ? selAnsch : anschlussFuer(selCm);
    selectedVariant = varianteFuer(selCm, selAnsch);
    redrawWaehler();
    updateImage(); updatePrice(); updateButton(); updateWas();
  }

  function setAnschluss(key) {
    if (!key || key === selAnsch) return;
    var e = (tabelle && tabelle[selCm]) || {};
    if (!e[key] || !e[key].available) return;
    selAnsch = key;
    anschGewaehlt = true;
    selectedVariant = varianteFuer(selCm, selAnsch);
    redrawWaehler();
    updateImage(); updatePrice(); updateButton(); updateWas();
  }

  function redrawWaehler() {
    var box = contentEl && contentEl.querySelector('[data-lw-qa-waehler]');
    if (box) box.innerHTML = renderWaehler();
  }

  /* ---------- UPDATE HELPERS ---------- */
  function updateImage() {
    var img = contentEl.querySelector('.lw-qa__thumb img');
    if (!img || !selectedVariant) return;
    var src = selectedVariant.featured_image ? selectedVariant.featured_image.src : (currentProduct.featured_image || '');
    if (src) img.src = imgUrl(src, '240x240');
  }
  function updatePrice() {
    var wrap = contentEl.querySelector('[data-lw-qa-price]');
    if (wrap && selectedVariant) wrap.innerHTML = buildPriceHtml(selectedVariant);
  }
  /* "Mit USB-C: 39,99€" ueber dem grossen Preis, durchgestrichen. Nur wenn
     USB-A gewaehlt IST und USB-C in derselben Groesse auch lieferbar waere -
     sonst waere es ein Vorherpreis, den es nie gab. Bei USB-C bleibt die
     Zeile stehen, aber leer, damit die Preiszeile ihre Hoehe behaelt. */
  function updateWas() {
    var was = contentEl && contentEl.querySelector('[data-lw-qa-was]');
    if (!was) return;
    var e = (tabelle && tabelle[selCm]) || {};
    var refC = e.usbc;
    if (selAnsch === 'usba' && refC && refC.available && selectedVariant &&
        refC.price > selectedVariant.price) {
      was.innerHTML = 'Mit USB-C: <s>' + eur(refC.price * quantity) + '</s>';
    } else {
      was.innerHTML = '&nbsp;';
    }
  }
  function updateButton() {
    var btn = contentEl.querySelector('[data-lw-qa-add]');
    if (!btn) return;
    var def = btn.querySelector('.lw-qa__cta-text-default');
    var da = !!(selectedVariant && selectedVariant.available);
    btn.disabled = !da;
    if (da) btn.classList.remove('is-loading', 'is-success');
    if (def) def.textContent = ctaText(selectedVariant);
  }

  /* ---------- ADD TO CART ----------
     ⚠️ KEINE EIGENSCHAFTEN UND KEINE AUFPREIS-ZEILEN MEHR. Groesse und
     Anschluss stecken seit dem Katalog-Umbau in der Variante selbst. Eine
     zusaetzliche Eigenschaft "Groesse" waere eine zweite Quelle fuer
     dieselbe Aussage - und genau die stand bis zum 21.09.2026 falsch im
     Warenkorb (siehe Kopf der Datei). */
  function addToCart() {
    if (isAdding || !selectedVariant || !selectedVariant.available) return;
    isAdding = true;
    lastError = null;

    var btn = contentEl.querySelector('[data-lw-qa-add]');
    hideError();
    if (btn) btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity: quantity }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (body) {
          var msg = body && (body.description || body.message) || 'Cart error';
          var e = new Error(msg); e._http = r.status; throw e;
        });
        return r.json();
      })
      .then(onSuccess)
      .catch(function (err) {
        console.error('[LWQuickAdd] Add fehlgeschlagen:', err);
        var isNetwork = !err._http && (err.message || '').toLowerCase().indexOf('failed to fetch') !== -1;
        lastError = {
          msg: isNetwork ? 'Keine Verbindung. Versuch’s nochmal.' :
                           'Hat nicht geklappt. Prüf kurz deine Verbindung und versuch’s nochmal.',
          isNetwork: isNetwork
        };
        showError();
        if (btn) btn.classList.remove('is-loading');
        isAdding = false;
      });
  }

  function onSuccess() {
    var btn = contentEl.querySelector('[data-lw-qa-add]');
    if (btn) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
    }

    /* Cart-State holen + Bubble updaten + Event dispatchen */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartBubble(cart);
        /* HOT-Bug-Fix #1: cart:updated dispatchen (siehe Sub-Chat 03) */
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart, source: 'quick-add' }
        }));
        /* Legacy hooks for existing helpers */
        if (window.LW24 && typeof window.LW24.flyToCart === 'function') {
          var flyImg = contentEl.querySelector('.lw-qa__thumb img');
          window.LW24.flyToCart(btn, flyImg ? flyImg.src : '');
        }
        if (window.LW24 && typeof window.LW24.checkMilestones === 'function') {
          window.LW24.checkMilestones();
        }
      })
      .catch(function () { /* swallow */ });

    /* Modal schliessen + Cart-Drawer öffnen */
    setTimeout(function () {
      closeModal();
      setTimeout(function () {
        if (btn) btn.classList.remove('is-success');
        isAdding = false;
        /* Cart-Drawer öffnen falls global verfügbar */
        if (window.LWCartDrawer && typeof window.LWCartDrawer.open === 'function') {
          try { window.LWCartDrawer.open(); } catch (e) {}
        }
      }, 320);
    }, 720);
  }

  /* ---------- ERROR (Glass-Card + Retry) ---------- */
  function showError() {
    var err = contentEl.querySelector('[data-lw-qa-error]');
    if (!err || !lastError) return;
    err.innerHTML =
      '<span class="lw-qa__error-msg">' + escHtml(lastError.msg) + '</span>' +
      '<button type="button" class="lw-qa__error-retry" data-lw-qa-retry>' +
        '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8a5 5 0 1 1 1.5 3.5"/><path d="M3 4v4h4"/></svg>' +
        'Erneut versuchen' +
      '</button>';
    err.classList.add('is-visible');
    var retry = err.querySelector('[data-lw-qa-retry]');
    if (retry) retry.addEventListener('click', function () { hideError(); addToCart(); });
  }
  function hideError() {
    var err = contentEl ? contentEl.querySelector('[data-lw-qa-error]') : null;
    if (!err) return;
    err.classList.remove('is-visible');
    err.innerHTML = '';
  }

  /* ---------- CART-BUBBLE REFRESH ---------- */
  function refreshCartBubble(cart) {
    if (!cart) return;
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    bubbles.forEach(function (b) {
      var span = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span:not(.visually-hidden)');
      if (span) span.textContent = cart.item_count;
      var sr = b.querySelector('.visually-hidden');
      if (sr) sr.textContent = cart.item_count + ' Artikel';
    });
    /* Section-render API als Fallback */
    fetch('/?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.shopify-section');
        if (src) el.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- PUBLIC API + DELEGATION ---------- */
  window.LWQuickAdd = {
    open: function (handle) { if (handle) openModal(handle); },
    close: closeModal,
    /* Nur fuer den Pruefstand: er setzt ein Produkt direkt ein und liest
       danach ab, was im Popup steht. Im Browser stoert das niemanden. */
    _pruefstand: {
      ensureDialog: ensureDialog,
      uebernehmen: uebernehmen,
      render: renderContent,
      setGroesse: setGroesse,
      setAnschluss: setAnschluss,
      setMotiv: setMotiv,
      stand: function () {
        return { cm: selCm, ansch: selAnsch, variante: selectedVariant };
      }
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lw-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-lw-quick-add');
    if (handle) openModal(handle);
  }, true);
})();
